import api from "./axios";

export const getNotifications = (params = {}) => api.get("/notifications", { params });
export const markAllRead = () => api.post("/notifications/mark-all-read");
export const markRead = (id) => api.post("/notifications/mark-read", { id });
